import { Navigate } from 'react-router-dom';
import { requireModule } from '../../auth/guards';
import { MODULES } from '../../auth/permissions';
import BillsPage from './pages/BillsPage';
import OutstandingPage from './pages/OutstandingPage';
import PaymentsPage from './pages/PaymentsPage';

export const accountsRoutes = [
  {
    path: '/payments',
    element: <PaymentsPage />,
    handle: { breadcrumb: 'Payments' },
    loader: requireModule(MODULES.PAYMENTS),
  },
  // V26 — proforma bills and bills from approved quotations, and what clients still owe.
  {
    path: '/bills',
    element: <BillsPage />,
    handle: { breadcrumb: 'Bills & Invoices' },
    loader: requireModule(MODULES.BILLS),
  },
  {
    path: '/outstanding',
    element: <OutstandingPage />,
    handle: { breadcrumb: 'Outstanding' },
    loader: requireModule(MODULES.OUTSTANDING),
  },
  // Legacy links into the credit/debit screens now land on the combined view.
  { path: '/credits', element: <Navigate to='/payments' replace /> },
  { path: '/debits', element: <Navigate to='/payments' replace /> },
];
